<template>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="6">
        <v-card class="elevation-12">
          <v-card-text>
            <v-form @keyup.native.enter="sendOTP">
              <v-row justify="center">
                <v-col cols="12" sm="12">
                  <v-text-field filled :label="$t('RevokePage.email')" v-model="email"></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12" class="text-right">
                  <custom-button v-bind:block="true" @click="sendOTP" :text="$t('Navigation.next')" />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-text>
            
             <v-row>
              <v-col cols="12" class="text-left">
                <b>{{ $t('audit_revoke_info') }}</b><br></br>
                {{ $t('audit_revoke_info1') }}
                 <a href="https://auth.sign8.eu/">{{ $t('here') }}</a>
                {{ $t('audit_revoke_info2') }}
                </v-col>
            </v-row>
            <v-divider class="my-4"></v-divider>
             <v-row>
                <v-col cols="12" class="text-left">
                  {{ $t('audit_revoke_info3') }}
                  <v-row>
                     <v-row><v-col>{{ $t('eIDAS') }}</v-col></v-row>
                    <v-col>
                      <a href="https://public.object.sign8.eu/de/eidas/Antrag_Widerruf_Siegel.pdf" target="_blank">{{ $t('Form_eidas_seal') }}</a>
                    </v-col>
                    <v-col>
                      <a href="https://public.object.sign8.eu/de/eidas/Antrag_Widerruf_Signatur.pdf" target="_blank">{{ $t('Form_eidas_signature') }}</a>
                    </v-col>
                  </v-row>
                  <v-row>
                     <v-row><v-col>{{ $t('ZertES') }}</v-col></v-row>
                    <v-col>
                      <a href="https://public.object.sign8.eu/ch/zertes/Antrag_Widerruf_Siegel.pdf" target="_blank">{{ $t('Form_ZertES_seal') }}</a>
                    </v-col>
                    <v-col>
                      <a href="https://public.object.sign8.eu/ch/zertes/Antrag_Widerruf_Signatur.pdf" target="_blank">{{ $t('Form_ZertES_signature') }}</a>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
             <v-row>
              <v-col cols="12" class="text-left">
                {{ $t('audit_revoke_info4') }}
                <a href="https://support.sign8.eu/portal/de/kb/articles/zertifikat-widerrufen-9-7-2024">{{ $t('https://support.sign8.eu/portal/widerruf') }}</a>
                </v-col>
            </v-row>
             <v-divider class="my-4"></v-divider>
            <v-row>
              <v-col cols="12" class="text-left">
                {{ $t('audit_revoke_info5') }}
                <a href="mailto:customerservice@sign8.eu">{{ $t('customerservice@sign8.eu') }}</a>
                {{ $t('or') }}
                <a href="mailto:customerservice@sign8.ch">{{ $t('customerservice@sign8.ch') }}</a>
                </v-col>
            </v-row>
           
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
</template>

<script>
import i18n from "../../i18n";
import CustomButton from "../../components/ui/input/CustomButton";
import HeaderBig from "../../components/ui/text/HeaderBig";
import HyperLink from "../../components/ui/text/HyperLink";

export default {
  name: "revoke-login",
  title: i18n.t("RevokePage.title"),
  components: {
    CustomButton,
    HeaderBig,
    HyperLink,
  },
  data() {
    return {
      email: "",
      mainColor: ""
    };
  },
  created() {
    this.mainColor = "#d2d1d1";
  },
  methods: {
    sendOTP() {
      this.$store
        .dispatch("data/sendOTP", { email: this.email })
        .then((res) => {
          this.$emit("otp", res);
          this.$emit("email", this.email);
        })
        .catch((err) => {
          log("RevokePage.Login.sendOTP() - " + err, "error");
        });
    }
  },
};
</script>
